module.exports = __webpack_public_path__ + "static/A01-9e491acaf9e599d29be8e941c64353a7.jpg";